module.exports = __webpack_public_path__ + "static/media/conveyor.dcc9e149.svg";